import { FC } from "react";

interface SecureItemProps {
  index: number;
  title: string;
  content: string;
}

export const SecureItem: FC<SecureItemProps> = ({ index, title, content }) => {
  return (
    <div className="item flex" key={index}>
      <div className="index-box">0{index + 1}</div>
      <div className="main-box">
        <h4>{title}</h4>
        <p className="fs16">{content}</p>
      </div>
    </div>
  );
};
